export default "__VITE_ASSET__DERPNxDw__"